import { Navigate, Route, Routes } from 'react-router-dom';

import { IdleWarning } from './components/IdleWarning';
import { RequireAuth, RequireRole } from './components/RequireAuth';
import { WorkspaceShell } from './components/WorkspaceShell';
import { AgenciesPage } from './pages/AgenciesPage';
import { AuditPage } from './pages/AuditPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { CrypticPage } from './pages/CrypticPage';
import { DashboardPage } from './pages/DashboardPage';
import { FeaturesPage } from './pages/FeaturesPage';
import { LoginPage } from './pages/LoginPage';
import { PNRsPage } from './pages/PNRsPage';
import { ReferencePage } from './pages/ReferencePage';
import { SecurityPage } from './pages/SecurityPage';
import { UsersPage } from './pages/UsersPage';

export function App() {
  return (
    <>
      <IdleWarning />
      <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/change-password"
        element={
          <RequireAuth>
            <ChangePasswordPage />
          </RequireAuth>
        }
      />

      {/* Signing in lands on the cryptic workspace, which carries its own
          chrome rather than the administrative shell. */}
      <Route
        path="/"
        element={
          <RequireAuth>
            <CrypticPage />
          </RequireAuth>
        }
      />

      <Route
        element={
          <RequireAuth>
            <WorkspaceShell />
          </RequireAuth>
        }
      >
        <Route path="/overview" element={<DashboardPage />} />
        <Route path="/pnrs" element={<PNRsPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route
          path="/admin/users"
          element={
            <RequireRole roles={['root', 'admin']}>
              <UsersPage />
            </RequireRole>
          }
        />
        <Route
          path="/admin/reference"
          element={
            <RequireRole roles={['root', 'admin']}>
              <ReferencePage />
            </RequireRole>
          }
        />
        <Route
          path="/admin/agencies"
          element={
            <RequireRole roles={['root', 'admin']}>
              <AgenciesPage />
            </RequireRole>
          }
        />
        <Route
          path="/admin/features"
          element={
            <RequireRole roles={['root', 'admin']}>
              <FeaturesPage />
            </RequireRole>
          }
        />
        <Route
          path="/admin/audit"
          element={
            <RequireRole roles={['root']}>
              <AuditPage />
            </RequireRole>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
